import { render, staticRenderFns } from "./ot-claim-details-form.vue?vue&type=template&id=479e8489&scoped=true&"
import script from "./ot-claim-details-form.vue?vue&type=script&lang=ts&"
export * from "./ot-claim-details-form.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claim-details-form.vue?vue&type=style&index=0&id=479e8489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479e8489",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VForm,VOverlay})
